import React from 'react'

export default props => (
    <footer className='main-footer'> 
        <strong> 
            Copyright &copy; 2021
            <a href='http://www.impa.br' target='_blank' rel="noopener noreferrer"> Impa</a>.
        </strong>
    </footer>
)